import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FileConfig } from 'classes-lib';

@Component({
  selector: 'app-file-section',
  templateUrl: './file-section.component.html',
  styleUrls: ['./file-section.component.scss'],
  standalone: false,
})
export class FileSectionComponent {
  @Input() fileSection: FormGroup;
  @Input() entityType: string;
  @Input() namespace: string;
  @Input() combinedOutput = false;
  @Output() uploadSourceChange = new EventEmitter<any>();

  get fileConfig(): FormGroup {
    return this.fileSection?.get('config') as FormGroup;
  }

  onDocumentOptionalChange(): void {
    this.fileConfig.patchValue({ optional: !this.fileConfig.value.optional });
    this.fileConfig.markAsDirty();
  }
}
